export default {
    'proforma-invoices': 'Proforma Invoices',
    'the-proforma-invoice': 'the Proforma Invoice?',
    'add-a-proforma-invoice': 'Add a Proforma Invoice',
    'proforma-invoice': 'proforma invoice',
}